/**
 * M17 — trial and plan. Days left, or "your trial ended" with what changed
 * (people paused). The only commercial module allowed on home; no ads on
 * home, ever. Card, never dismissable; the tap is `open` (premium). Every
 * number (days, paused count, the free limit) is a payload field.
 */

import { HomeCard, HomeChevron } from '../HomeKit';
import { formatShortDate, plural } from '../format';
import type { ModuleProps } from '../moduleTypes';

export function TrialModule({ module, onAction }: ModuleProps) {
  if (module.type !== 'trial') return null;
  const { payload } = module;

  let body: string;
  let sub: string;
  if (payload.variant === 'ended') {
    const ended = payload.endedAt ? formatShortDate(payload.endedAt) : '';
    body = payload.pausedCount > 0 ? `Your trial ended — f8 paused ${plural(payload.pausedCount, 'person', 'people')}` : `Your trial ended${ended ? ` ${ended}` : ''}`;
    sub = `notes are safe · free remembers ${payload.freeLimit}`;
  } else {
    const d = payload.daysLeft;
    body = d == null ? 'Your trial is ending' : d <= 0 ? 'Your trial ends today' : d === 1 ? 'Your trial ends tomorrow' : `Your trial ends in ${d} days`;
    sub = 'premium remembers everyone';
  }

  return (
    <HomeCard
      reason={module.reason}
      body={body}
      sub={sub}
      right={<HomeChevron />}
      dismissable={false}
      onOpen={() => onAction?.({ kind: 'open' }, module)}
    />
  );
}
